<template>
  <b-modal
    v-if="shouldShow"
    visible
    id="TourMessage"
    @hidden="dismiss(id)"
    @show="$emit('show', id)"
    :class="`${id == 'table' ? 'mx-2' : ''} tour-message mt-2`"
    :title="content.title"
    hide-footer
    size="xl"
  >
    <template #default="{ hide }">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <div>
            <p v-html="content.message" :class="content.video ? 'my-4 lead' : ''"></p>
            <b-button @click="hide()" :variant="content.variant || 'outline-primary'">{{content.cta || 'Dismiss'}}</b-button>
          </div>
        </div>
        <video v-if="content.video" autoplay loop muted playsinline class="my-4 ml-4" :style="{maxWidth: 'min(50%, 600px)'}">
          <source :src="content.video" type="video/webm">
        </video>
        <b-img v-else-if="content.image" :src="content.image" class="my-4 ml-4" :style="{maxWidth: 'min(50%, 600px)'}" />
      </div>
    </template>
  </b-modal>
</template>
<style scoped>
img, video {
    border: 2px solid var(--teal);
    border-radius: 5px;
    box-shadow: 1px 3px 3px rgba(0,0,0,.2);
    /* border-top-width: 15px; */
}
</style>
<script>
import ACCOUNT_QUERY from '@/graphql/AccountQuery.gql'
import ACCOUNT_LOG_MUTATION from '@/graphql/AccountLogMutation.gql'
import * as Sentry from '@sentry/vue'
import {get, isEmpty} from 'lodash'

export default {
  name: 'TourMessage',
  props: ['id', 'account'],
  data() {
    return {
      messages: [],
    }
  },
  watch: {
    id() {
      if(this.shouldShow) {
        // Sequential modals won't show without this
        this.$bvModal.show('TourMessage')
      }
    }
  },
  computed: {
    isDismissed() {
      return get(this.account, 'alerts_dismissed', []).some(e => e.foreign_key == this.id)
    },
    shouldShow() {
      return get(this.account, 'id') && !this.isDismissed && !isEmpty(this.content)
    },
    content() {
      return this.messages.find(e => e.id == this.id)
    },
    variant() {
      return get(this.content, 'variant', 'primary')
    }
  },
  methods: {
    async dismiss(id) {
      const object = {
        action: 'alert.dismissed',
        foreign_key: id,
        site_id: null,
      }
      await this.$apollo.mutate({
        mutation: ACCOUNT_LOG_MUTATION,
        variables: {object},
        update: function(cache) {
          const query = {query: ACCOUNT_QUERY}
          query.data = cache.readQuery(query)
          object.__typename = 'z1_account_log'
          query.data.account[0].alerts_dismissed.push(object)
          cache.writeQuery(query)
        }
      })
      _zyppy.track('Alert Dismissed', {id})
      this.$emit('dismissed', id)
    }
  }
}
</script>